export default {
    fornecedores: [],
    fornecedor: {},
    ultimaAtualizacaoListaFornecedor: null
}
